
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diagnostics",
      function () {
        return require("private-next-pages/diagnostics/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/diagnostics"])
      });
    }
  